import { queries } from "lib/build/dashboards/shared";

import { useLastEventValueByQuery } from "src/features/events";

export function useMaidenNameOfMother(): string | undefined {
	return useLastEventValueByQuery<string>(queries.maidenNameOfMother);
}
